var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "HKLModal",
        {
          ref: "modal",
          staticClass: "temp-close-reopen-modal",
          attrs: {
            okBtnAction: "saveAndNotify",
            size: "medium",
            title: _vm.title,
          },
          on: { onCloseClick: _vm.cleanModalState },
        },
        [
          _c(
            "div",
            { staticClass: "modal-content check-valid" },
            [
              _c(
                "div",
                { staticClass: "date-group row" },
                [
                  _vm.record.type === _vm.MOVE_TYPE.TEMP_ClOSE
                    ? [
                        _c(
                          "span",
                          { staticClass: "required-flag date-group__label" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("handover.moveInOut.duration"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("HKLDateRange", {
                          attrs: {
                            required: true,
                            displayRange: [
                              { to: _vm.record.duration[1] },
                              { to: null },
                            ],
                            placeholders: [
                              _vm.$t("projectViewAll.startFrom"),
                              _vm.$t("projectViewAll.until"),
                            ],
                          },
                          model: {
                            value: _vm.record.duration,
                            callback: function ($$v) {
                              _vm.$set(_vm.record, "duration", $$v)
                            },
                            expression: "record.duration",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.record.type === _vm.MOVE_TYPE.REOPEN
                    ? [
                        _c(
                          "span",
                          { staticClass: "required-flag date-group__label" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("handover.moveInOut.reopenDate"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("DatePicker", {
                          attrs: {
                            required: true,
                            calendarButton: true,
                            calendarButtonIcon: "fa fa-calendar",
                            value: _vm.formatDate(_vm.record.date),
                          },
                          on: {
                            selected: function (val) {
                              return _vm.updateRecord("date", val)
                            },
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("TextField", {
                staticClass: "premises-textfield",
                attrs: {
                  required: true,
                  label: _vm.$t("handover.moveInOut.header.premises"),
                  placeholder: _vm.$t(
                    "handover.moveInOut.pleaseInputFloorPremises"
                  ),
                  value: _vm.record.premises,
                },
                on: {
                  updateValue: function (val) {
                    return _vm.updateRecord("premises", val)
                  },
                },
              }),
              _vm._v(" "),
              _c("TextField", {
                staticClass: "remark-textfield",
                attrs: {
                  label: _vm.$t("handover.moveInOut.header.remarks"),
                  value: _vm.record.remark,
                },
                on: {
                  updateValue: function (val) {
                    return _vm.updateRecord("remark", val)
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("HKLModal", {
        ref: "savingConfirmModalRef",
        attrs: { title: _vm.$t("handover.moveInOut.message.beforeSaving") },
        on: { onOkClick: _vm.save },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }